<template>
  <div class="bbp-timer-modal-body">
    <div class="bbp-timer-modal-body__counter">
      <BBPTimerModalPanel
        v-if="isTimer"
        :row="row"
        :column="column"
        :comment="valueObj.textAreaModel.comment"
        :body="body"
        :isError.sync="isError"
      />
      <BBPTimerModalManual
        v-else
        :row="row"
        :column="column"
        :isSave="isSave"
        :body="body"
        :day="valueObj.calendarModel"
        :isSubproject="isSubproject"
        :isHourProject="isHourProject"
      />
    </div>
    <div
      v-if="selectSettings.isHide"
      class="bbp-timer-modal-body-item"
    >
      <div class="bbp-timer-modal-body__title">
        {{ selectSettings.title }}
      </div>
      <BBPSelectInput
        :input="selectSettings"
        :model="valueObj"
        @input="onChangeSelectSubproject"
      />
    </div>
    <div class="bbp-timer-modal-body-item">
      <div class="bbp-timer-modal-body__title">
        {{ textAreaSettings.title }}
      </div>
      <BBPTextarea
        :input="textAreaSettings"
        :model="valueObj.textAreaModel"
        :errorText="textAreaSettings.errorText"
        @input="onChangeTextarea"
      />
    </div>
    <BBPCheckbox
      v-if="instanceStatus"
      class="bbp-timer-modal-body__checkbox"
      title="Add to History Tab of Clients"
      :defaultValue="valueObj.clientIsTab"
      @change="onChangeClientTab"
    />
    <BBPTimerModalSelectCompany
      v-if="instanceStatus"
      :companies="valueObj.companies"
      :row="row"
      :companyIsTab="valueObj.companyIsTab"
      :error.sync="selectCompanyError"
      @onChangeCompanyTab="onChangeCompanyTab"
      @setSelect="setSelect"
      @onDelete="onDelete"
    />
    <div
      :class="[
        'bbp-timer-modal-body__data-picker',
        isTimer && 'bbp-timer-modal-body__data-picker_disabled'
      ]"
    >
      <BBPDatePicker
        :input="calendarSettings"
        :model="valueObj.calendarModel"
        styleType="mini"
        @input="onChangeDate"
      />
    </div>
  </div>
</template>

<script>
import BBPCheckbox from '@/components/Main/InputFields/BBPCheckbox/BBPCheckbox'
import BBPDatePicker from '@/components/Main/BBPForm/BBPDatePicker/BBPDatePicker'
import BBPTextarea from '@/components/Main/BBPForm/BBPTextarea/BBPTextarea'
import BBPTimerModalPanel
  from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalPanel/BBPTimerModalPanel'
import BBPTimerModalManual
  from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalManual/BBPTimerModalManual'
import BBPTimerModalSelectCompany from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalSelectCompany'
import BBPSelectInput from '@/components/Main/BBPForm/BBPSelectInput/BBPSelectInput'
import { REGULAR } from '@/constants/projectTypes'
import { REMINDER_STATUS } from '@/constants/recurReminders'

export default {
  name: 'BBPTimerModalBody',
  components: {
    BBPSelectInput,
    BBPTimerModalSelectCompany,
    BBPTimerModalManual,
    BBPTimerModalPanel,
    BBPTextarea,
    BBPDatePicker,
    BBPCheckbox
  },
  props: {
    isTimer: {
      type: Boolean,
      default: true
    },
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    body: {
      type: Object,
      default: () => ({})
    },
    isSave: {
      type: Boolean,
      default: false
    },
    isErrorComment: {
      type: Boolean,
      default: false
    },
    isErrorSelect: {
      type: Boolean,
      default: false
    },
    isSubproject: {
      type: Boolean,
      default: false
    },
    isHourProject: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    textAreaSettings: {
      model: 'comment',
      title: 'Comment',
      height: '115px',
      placeholder: 'Enter a comment',
      errorText: ''
    },
    selectSettings: {
      title: 'Subproject',
      model: 'subprojectId',
      placeholder: 'No entries',
      disabled: false,
      isHide: false,
      options: []
    },
    calendarSettings: {
      mode: 'single',
      model: 'startDate',
      format: 'DD-MMM',
      maxDate: new Date()
    },
    valueObj: {
      clientIsTab: false,
      companyIsTab: false,
      subprojectId: undefined,
      calendarModel: {
        startDate: new Date()
      },
      textAreaModel: {
        comment: ''
      },
      companies: [{}]
    },
    isError: false,
    options: []
  }),
  computed: {
    selectCompanyError: {
      get () {
        return this.isErrorSelect
      },
      set (data) {
        this.$emit('update:isErrorSelect', data)
      }
    },
    instanceStatus () {
      const { instanceStatus } = this.column
      const { PROJECT } = REMINDER_STATUS
      return instanceStatus === PROJECT
    },
    error: {
      get () {
        return this.isErrorComment
      },
      set (data) {
        this.$emit('update:isErrorComment', data)
      }
    },
    activeTimer: {
      get () {
        return this.$store.getters.activeTimer
      },
      set (data) {
        this.$store.dispatch('setActiveTimer', data)
      }
    },
    clientCompanies () {
      return this.$store.getters.clientCompanies
    },
    isRegularProject () {
      const { projectType = REGULAR } = this.row
      return REGULAR.id === projectType.id
    },
    projectsList: {
      get () {
        return this.$store.getters.projectsList
      },
      set (data) {
        this.$store.dispatch('setProjectsList', data)
      }
    }
  },
  methods: {
    onChangeClientTab ({value}) {
      this.valueObj = {
        ...this.valueObj,
        clientIsTab: value
      }
    },
    onChangeCompanyTab (value) {
      this.valueObj = {
        ...this.valueObj,
        companyIsTab: value
      }
    },
    onChangeDate (date) {
      this.valueObj = {
        ...this.valueObj,
        calendarModel: {
          startDate: date
        }
      }
    },
    onChangeTextarea (comment) {
      this.valueObj = {
        ...this.valueObj,
        textAreaModel: {
          comment
        }
      }
    },
    onChangeSelectSubproject ({ id }) {
      this.activeTimer.subprojectId = id
    },
    createDefaultValue () {
      const { subTimers = {}, subprojectId } = this.activeTimer
      const { options = [] } = this.selectSettings
      const activeSub = options.find((el) => el.id === subprojectId) || options[0]
      const { comment, companyIsTab, clientIsTab, companies = [] } = subTimers
      this.valueObj = {
        ...this.valueObj,
        companyIsTab,
        clientIsTab,
        subprojectId: this.isSubproject ? this.row : activeSub,
        textAreaModel: {
          comment
        },
        companies: companies.length ? companies : [{}]
      }
    },
    setSelect (value) {
      const { companies } = this.valueObj
      const [firstItem] = companies

      this.valueObj = {
        ...this.valueObj,
        companies: Object.keys(firstItem).length ? [...companies, value] : [value]
      }
    },
    onDelete (index) {
      this.valueObj.companies.splice(index, 1)
      if (this.valueObj.companies.length === 0) {
        this.valueObj.companies.push({})
      }
    },
    setSelectOptions () {
      if (this.isSubproject) {
        const { parentProjectId } = this.row
        const currentParent = this.projectsList.find((el) => el._id === parentProjectId)
        const { childrenProjects = [] } = currentParent
        childrenProjects.forEach((el) => { el.id = el._id })
        return childrenProjects
      } else {
        const { childrenProjects = [] } = this.row
        childrenProjects.forEach((el) => { el.id = el._id })
        return childrenProjects
      }
    },
    addDefaultValueSelect () {
      const items = this.setSelectOptions()
      this.selectSettings.options = items
      this.selectSettings.disabled = !items.length
      this.selectSettings.isHide = !this.isRegularProject
      this.activeTimer.subProjectsList = items
    }
  },
  watch: {
    isSave () {
      this.options = [...this.clientCompanies]
    },
    isError () {
      this.textAreaSettings.errorText = 'mandatory field'
    },
    error () {
      this.textAreaSettings.errorText = 'mandatory field'
    },
    'valueObj.textAreaModel.comment' (newVal) {
      if (newVal) {
        this.textAreaSettings.errorText = false
        this.error = false
      }
    },
    valueObj: {
      handler (newValue) {
        const { clientIsTab, companyIsTab, textAreaModel = {}, companies = [] } = newValue
        const { comment } = textAreaModel
        const body = {
          clientIsTab,
          companyIsTab,
          comment,
          companies: companyIsTab ? companies.map((el) => el._id) : []
        }
        this.$emit('update:body', body)
      },
      deep: true
    }
  },
  beforeMount () {
    this.addDefaultValueSelect()
    this.createDefaultValue()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

  .bbp-timer-modal-body {

    &__title {
      font-size: 13px;
      line-height: 16px;
      font-weight: 600;
      color: $color-denim;
      margin: 0 0 8px 0;
    }

    &__counter {
      margin: 20px 0 20px 0;
      height: 36px;
    }

    &__checkbox {
      margin: 0 0 11px 0;
    }

    &__data-picker {
      margin: 20px 0 0 0;
      width: max-content;
    }
  }

  .bbp-timer-modal-body-item {
    margin: 0 0 12px 0;
  }
</style>

<style lang="scss">
@import "../../../../../sass/variables";

  .bbp-timer-modal-body__data-picker_disabled {
    .bbp-date-picker {
      pointer-events: none;
    }

    .bbp-icon-calendar {
      color: $color-silver !important;
    }

    .bbp-date-picker-body__date {
      color: $color-silver !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalBody.vue